import { makeVar } from "@apollo/client";
import { User } from "../generated/graphql";

export const setMe = makeVar<Pick<User, 'id' | 'role' | 'name'> | undefined>(undefined);

export const setIsMobile = makeVar<boolean>(false);